import { RegisterCompanyModel } from "./RegisterCompanyModels";
import { Reducer } from "redux";

export enum ActionType {
    RegisterRequest = "REGISTER/COMPANY_REQUEST",
    Submit = "REGISTER/COMPANY_SUBMIT",
    Success = "REGISTER/COMPANY_SUCCESS",
    SuccessContinue = "REGISTER/COMPANY_SUCCESS_CONTINUE",
    Error = "REGISTER/COMPANY_ERROR"
}

interface RegisterCompanyRequestAction {
    type: ActionType.RegisterRequest;
}

interface SubmitAction {
    type: ActionType.Submit,
    data: RegisterCompanyModel
}

interface SuccessAction {
    type: ActionType.Success
}

interface SuccessContinueAction {
    type: ActionType.SuccessContinue
}

interface ErrorAction {
    type: ActionType.Error,
    error: any
}

export const actionCreators = {
    registerCompany: () => <RegisterCompanyRequestAction>{ type: ActionType.RegisterRequest },
    registerSubmit: (data: RegisterCompanyModel) => <SubmitAction>{ type: ActionType.Submit, data },
    registerSuccess: () => <SuccessAction>{ type: ActionType.Success },
    registerSuccessContinue: () => <SuccessContinueAction>{ type: ActionType.SuccessContinue },
    registerError: (error: any) => <ErrorAction>{ type: ActionType.Error, error }
}

export interface RegisterCompanyState {
    success: boolean;
}

const initialState: RegisterCompanyState = {
    success: false
}

type RegisterAction = RegisterCompanyRequestAction | SuccessAction

export const reducer: Reducer<RegisterCompanyState> = (state: RegisterCompanyState, action: RegisterAction) => {
    switch (action.type) {
        case ActionType.RegisterRequest:
            return {
                success: false
            }
        case ActionType.Success:
            return {
                success: true
            }
        default:
            const ex: never = action;
    }

    return state || initialState;
}



// WEBPACK FOOTER //
// ./src/register/company/registerCompanyStore.ts